import moment from "moment";
import { 
  RoEasyBinTransfer,
  RoLocation,
  vRdxUserInfo,
} from "../../Redux/roStore";
import {
  EasyBinTransfer_Delete,
  EasyBinTransfer_Des,
  EasyBinTransfer_Src,
  EasyBinTransfer_Summary,
  Item_Search,
} from "../../Server/ApiV2";
import {
  Get_ToggleDropDown_binsearch_Load,
  fAlertToast,
} from "../../Utility/Utilitys";
import { Src_Set } from "./SliceEasyBinTransfer";
import { fExecuteAPI } from "../../Server/Apis";

export const statusData = [
  {
    id: "All",
    statusName: "All",
  },
  {
    id: "Enter",
    statusName: "Enter",
  },
  {
    id: "Post",
    statusName: "Post",
  },
  {
    id: "Delete",
    statusName: "Delete",
  },
];

export const typeData = [
  {
    id: "All",
    typeName: "All",
  },
  {
    id: "BinTransfer",
    typeName: "Bin Transfer",
  },
  {
    id: "ItemTransfer",
    typeName: "Item Transfer",
  },
  {
    id: "CardIDTransfer",
    typeName: "Card ID Transfer",
  },
];

export const GetSummary = async (
  setData,
  v_Loc,
  v_Date1,
  v_Date2,
  v_Status,
  v_Type
) => {
  // let { Summary } = RoEasyBinTransfer();
  const vRdxUserInfoObj = vRdxUserInfo();

  let apiObj = {
    v_Loc: v_Loc,
    v_Date1: moment(v_Date1).format("MM/DD/YYYY"),
    v_Date2: moment(v_Date2).format("MM/DD/YYYY"),
    v_Status: v_Status,
    v_UserCd: vRdxUserInfoObj.UserID,
    v_Type: v_Type,
  };
  const Resp = await EasyBinTransfer_Summary(apiObj);
  if (Resp?.status === 200) {
    setData(Resp?.data?.ResultSet);
    return Resp?.data?.ResultSet;
  }
};
export const GetSrc = async (dispatch) => {
  let { Src } = RoEasyBinTransfer();
  let { Summary } = RoEasyBinTransfer();
  const vRdxUserInfoObj = vRdxUserInfo();

  let apiObj = {
    VocNo: Src.DocNo,
    VocDt: moment(Src.Date).format("MM/DD/YYYY"),
    Loc: Src.LocCode,
    Type: Src.Type,
    BinCdFrom: Src.BinCodeFrom,
    ItmCd: Src.ItemCode,
    CardID: Src.CardId,
    Qty: Src.Qty,
    Unit: Src.UnitCode,
    BaseQty: Src.BaseQty,
    UserCd: vRdxUserInfoObj.UserID,
  };
  const Resp = await EasyBinTransfer_Src(apiObj);
  if (Resp?.status === 200) {
    console.log(Resp?.data?.ResultSet);

    dispatch(
      Src_Set({
        ...Src,
        DocNo: Resp?.data?.ResultSet[0]?.VocNo,
      })
    );
    return Resp?.data?.ResultSet;
  }
};
export const GetDes = async (navigate) => {
  let { Src } = RoEasyBinTransfer();
  // let { Summary } = RoEasyBinTransfer();
  // const vRdxUserInfoObj = vRdxUserInfo();

  let apiObj = {
    VocNo: Src.DocNo,
    BinCdTo: Src.BinCodeTo,
    Loc: Src.LocCode,
    type:Src.Type
  };
  const Resp = await EasyBinTransfer_Des(apiObj);
  if (Resp?.status === 200) {
    console.log(Resp?.data?.ResultSet);
    fAlertToast("SUCCESS", "Successfully Saved");
    navigate("/EasyBinTransferSummary");
    return Resp?.data?.ResultSet;
  }
};
export const GetDelete = async (navigate) => {
  let { Src } = RoEasyBinTransfer();
  // let { Summary } = RoEasyBinTransfer();
  // const vRdxUserInfoObj = vRdxUserInfo();

  let apiObj = {
    VocNo: Src.DocNo, 
  };
  const Resp = await EasyBinTransfer_Delete(apiObj);
  if (Resp?.status === 200) {
    console.log(Resp?.data?.ResultSet);
    fAlertToast("SUCCESS", "Deleted successfully");
    navigate("/EasyBinTransferSummary");
    return Resp?.data?.ResultSet;
  }
};

export const fBinNameFromKey = async (e, dispatch,xfocus=()=>{}) => {
  let { Src } = RoEasyBinTransfer();
  if (e.key === "Enter" || e?._reactName === "onClick") {
    const vReasonWmBin = await Get_ToggleDropDown_binsearch_Load(
      Src.BinNameFrom,
      "Any",
      "Y",
      Src.LocCode
    );

    if (vReasonWmBin?.length > 0) {
      dispatch(
        Src_Set({
          ...Src,
          BinCodeFrom: vReasonWmBin[0].UId,
          BinNameFrom: vReasonWmBin[0].Name1,
        })
      );
      xfocus(e)
    } else {
      fAlertToast("FAILED", "Wrong BinName");

      dispatch(
        Src_Set({
          ...Src,
          BinCodeFrom: "",
        })
      );
    }
  }
  if (e.key === "Backspace" || (e.key === "Delete" && Src.BinNameFrom == "")) {
    dispatch(
      Src_Set({
        ...Src,
        BinCodeFrom: "",
      })
    );
  }
};
export const fBinNameToKey = async (e, dispatch,xfocus=()=>{}) => {
  let { Src } = RoEasyBinTransfer();
  if (e.key === "Enter" || e?._reactName === "onClick") {
    const vReasonWmBin = await Get_ToggleDropDown_binsearch_Load(
      Src.BinNameTo,
      "Any",
      "Y",
      Src.LocCode
    );

    if (vReasonWmBin?.length > 0) {
      dispatch(
        Src_Set({
          ...Src,
          BinCodeTo: vReasonWmBin[0].UId,
          BinNameTo: vReasonWmBin[0].Name1,
        })
      );
      xfocus(e)
    } else {
      fAlertToast("FAILED", "Wrong BinName");

      dispatch(
        Src_Set({
          ...Src,
          BinCodeTo: "",
        })
      );
    }
  }
  if (e.key === "Backspace" || (e.key === "Delete" && Src.BinNameTo == "")) {
    dispatch(
      Src_Set({
        ...Src,
        BinCodeTo: "",
      })
    );
  }
};
//API LOADING_ITEMSEARCH_GETROW
export const GetItem = async (dispatch) => {
  let { Src } = RoEasyBinTransfer();
  const apiObj = {
    Data: Src.ItemName,
    Type: "barcode",
    Loc: Src.LocCode,
  };
  const Resp = await Item_Search(apiObj);
  if (Resp?.status === 200) {
    if (Resp?.data?.ResultSet.length > 0) {
      dispatch(
        Src_Set({
          ...Src,
          ItemCode: Resp?.data?.ResultSet[0].ItmCd,
          ItemName: Resp?.data?.ResultSet[0].Name1,
        })
      );
    } else {
      dispatch(
        Src_Set({
          ...Src,
          ItemCode: "",
        })
      );

      fAlertToast("WARNING", "Wrong card Id");
    }
  }
};



export const fIsEnable=()=>{
  let { Src } = RoEasyBinTransfer();
  return Src?.Status?.toUpperCase() == 'POST' || Src?.Status?.toUpperCase() == 'DELETE'
}